/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'pool-group-member';

export const poolGroupMembersModalBreadcrumbTitle = `${prefix}.poolGroupMembersModalBreadcrumbTitle`;

export const ENGLISH = {
    [poolGroupMembersModalBreadcrumbTitle]: 'Pool Group Member',
};
